<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedAccountTypes"
      multi-select
      class="tw-w-full"
      :label="meta.filter.quickFilter ? '' : $t('Account types')"
      :list="accountTypes"
      :max-labels-visible="meta.filter.quickFilter ? 1 : 10"
      :placeholder="$t('All account types')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { AccountType } from '@/gql/graphql'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedAccountTypes: ModelRef<string[]> = defineModel({
  default: () => [],
})

const accountTypeLabels: Record<string, string> = {
  [AccountType.Worker]: $t('Worker'),
  [AccountType.Company]: $t('Company'),
  [AccountType.Recruiter]: $t('Recruiter'),
  [AccountType.Organisation]: $t('Organisation'),
  [AccountType.Partner]: $t('Partner'),
}

const orderedAccountTypes = [
  AccountType.Worker,
  AccountType.Company,
  AccountType.Recruiter,
  AccountType.Organisation,
  AccountType.Partner,
]

const accountTypes = computed(() =>
  orderedAccountTypes.map((value) => ({
    label: accountTypeLabels[value] ?? value,
    value,
  })),
)
</script>
